import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { WorksiteDetail } from './core/models/worksite-detail.model';
import { UtilitiesQuery } from './core/queries/utilities.query';

@UntilDestroy()
@Component({
  selector: 'lib-oreg',
  templateUrl: './oreg-lib.component.html',
  styleUrls: ['./oreg-lib.component.scss'],
  standalone: false,
})
export class OregLibComponent implements OnInit {
  showSearchView: boolean;
  showCreateView: boolean;
  selectedWorksite: WorksiteDetail;
  backToSearch: boolean;

  @Input() alreadySelectedWorksites: string[];
  @Input() isFinancierSearch: false;
  @Input() alreadySelectedFinanciers: string[];
  @Output() selectedWorksiteEvent = new EventEmitter<WorksiteDetail>();

  constructor(
    private utilitiesQuery: UtilitiesQuery,
    private translocoService: TranslocoService,
  ) {}

  ngOnInit() {
    this.utilitiesQuery
      .loadUtilities(this.translocoService.getActiveLang())
      .pipe(untilDestroyed(this))
      .subscribe();
    this.showSearchView = true;
  }

  onCreateWorksite() {
    this.showCreateView = true;
  }

  onCreateCompanyAndWorksite() {
    this.showCreateView = true;
  }

  onNavigateToSearch() {
    this.showCreateView = false;
    this.backToSearch = true;
  }

  onSelectWorksite(worksite: WorksiteDetail) {
    this.selectedWorksiteEvent.emit(worksite);
  }
}
